import React, { FC } from 'react';
import { Filter } from '../../models/Filter';
import { PaginatedFilterChip } from './PaginatedFilterChip';
import { useFilter } from '../../contexts/table/FilterContext';
import { Name } from '../../models/Name';

interface Props {
    filters: Filter[];
    toggleFilterModal: (trigger: string) => void;
    disableFilterToggling:boolean
}

const FilterChips: FC<Props> = ({ filters = [], toggleFilterModal,disableFilterToggling=false }) => {
    const filterContext = useFilter();

    const handleItemClick = (item: any, index: number, visibleOptions: Name[], filterKey: string) => {
        const realItem = visibleOptions[index] ?? visibleOptions.find(option => option.value === (item?.value ?? item));
        if (realItem) {
            filterContext.updateFilters(filterKey, realItem.value, realItem.label, filterKey, realItem.elementSysname);
        }
    }

    return <div className="flex flex-wrap w-full select-none">
        {filters.filter((filter) => filter.showFilterChips !== false)
            .map((filter, filterIndex) =>
                <PaginatedFilterChip
                    toggleFilterModal={toggleFilterModal}
                    key={'pagedchip-' + filter.key}
                    accessor={filter.key}
                    filters={filters}
                    lookupList={filterContext.lookup ?? []}
                    handleItemClick={(item, index, filterKey, visibleOptions) => handleItemClick(item, index, visibleOptions, filterKey)}
                    removeFilterWithKey={filterKey => filterContext.closeFilter(filterKey)}
                    disableFilterToggling={disableFilterToggling} />
            )}
    </div>
}

export default FilterChips;


